<template>
    <div class="check_summary_normal_layout">
        <div v-show="show_contents" v-for="(consignee_grouped_core_waybills, consignee_company_name) in _.groupBy(check_core_waybills, 'consignee_company_name')">
            <div ref="printable_check_summaries" class="A4 divided" style="padding: 25px;">
                <h2 class="ui center aligned header">
                    <img :src="logo_url">
                    <div class="content">
                        {{ title }}({{ customer_service_hotline }})
                        <div class="sub header">{{ sub_title }}</div>
                    </div>
                </h2>
                <div class="ui divider"></div>
                <table class="ui very basic compact sixteen column table">
                    <thead>
                        <tr>
                            <th class="four wide">收執聯</th>
                            <!-- <th class="four wide">
                                交貨方：{{ $store.state.provider.node.company_name }}
                            </th> -->
                            <th class="six wide">
                                收貨方：{{ (consignee_company_name == 'null' || consignee_company_name == null) ? '':consignee_company_name }}
                            </th>
                            <th class="six wide">
                                點交時間：{{ human_datetime(Date.now(), "YYYY-MM-DD HH:mm") }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="4" class="sixteen wide">
                                <table class="ui very basic table">
                                    <tbody>
                                        <tr>
                                            <td class="six wide">
                                                點交件數： {{ (consignee_grouped_core_waybills.length).toLocaleString() }}件
                                            </td>
                                            <td rowspan="3" class="eight wide">
                                                <p>本份文件內含：</p>
                                                <p>1. 點交單</p>
                                                <p>2. 點交明細</p>
                                                <p>本文件一式兩份，點交後雙方簽名後各自留存。</p>
                                                <p></p>
                                            </td>
                                            <td rowspan="3" class="two wide"></td>
                                        </tr>
                                        <tr>
                                            <td>
                                                簽名欄：________________
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr v-for="(cws, operation_identity) in _.groupBy(consignee_grouped_core_waybills, 'operation.identity')">
                            <td colspan="4" class="sixteen wide">
                                <table class="ui very basic compact table" v-if="operation_identity && cws[0].operation">
                                    <tbody>
                                        <tr>
                                            <td class="eight wide">
                                                <p>訂單：{{ cws[0].operation.number }}</p>
                                                <p>檔案名稱：{{ cws[0].operation.original_file_name }}</p>
                                                <p>備註：{{ cws[0].operation.provider_note }}</p>
                                            </td>
                                            <td class="four wide">
                                            </td>
                                            <td class="four wide">
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="ui very basic compact table" v-else>
                                    <tbody>
                                        <tr>
                                            <td class="eight wide">
                                                <p>訂單：不在訂單內</p>
                                                <p>檔案名稱：N/A</p>
                                                <p>備註：N/A</p>
                                            </td>
                                            <td class="four wide">
                                            </td>
                                            <td class="four wide">
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="ui basic black mini label" v-for="(core_waybill, index) in cws" style="margin:0;">
                                    {{ index+1 }}.{{ core_waybill.material.class_name == "House" ? core_waybill.number : core_waybill.original_number }}@{{ latest_condition_time(core_waybill) }}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- <div ref="printable_check_summaries" class="A4 divided" style="padding: 25px;">
                <h2 class="ui center aligned header">
                    <img :src="logo_url">
                    <div class="content">
                        {{ title }}({{ customer_service_hotline }})
                        <div class="sub header">{{ sub_title }}</div>
                    </div>
                </h2>
                <div class="ui divider"></div>
                <table class="ui very basic compact sixteen column table">
                    <thead>
                        <tr>
                            <th class="four wide">
                                收貨方收執聯
                            </th>
                            <th class="four wide">
                                收貨方：{{ (consignee_company_name == 'null' || consignee_company_name == null) ? '':consignee_company_name }}
                            </th>
                            <th class="four wide">
                                點交時間：{{ human_datetime(Date.now(), "YYYY-MM-DD HH:mm") }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="4" class="sixteen wide">
                                <table class="ui very basic table">
                                    <tbody>
                                        <tr>
                                            <td class="six wide">
                                                點交件數： {{ (consignee_grouped_core_waybills.length).toLocaleString() }}件
                                            </td>
                                            <td rowspan="3" class="eight wide">
                                                <p>本份文件內含：</p>
                                                <p>1. 點交單</p>
                                                <p>2. 點交明細</p>
                                                <p>本文件一式兩份，點交後雙方簽名後各自留存。</p>
                                                <p></p>
                                            </td>
                                            <td rowspan="3" class="two wide"></td>
                                        </tr>
                                        <tr>
                                            <td>
                                                收貨方簽名欄：________________
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr v-for="(cws, operation_identity) in _.groupBy(consignee_grouped_core_waybills, 'operation.identity')">
                            <td colspan="4" class="sixteen wide">
                                <table class="ui very basic compact table" v-if="operation_identity && cws[0].operation">
                                    <tbody>
                                        <tr>
                                            <td class="eight wide">
                                                <p>訂單：{{ cws[0].operation.number }}</p>
                                                <p>檔案名稱：{{ cws[0].operation.original_file_name }}</p>
                                                <p>備註：{{ cws[0].operation.provider_note }}</p>
                                            </td>
                                            <td class="four wide">
                                            </td>
                                            <td class="four wide">
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="ui very basic compact table" v-else>
                                    <tbody>
                                        <tr>
                                            <td class="eight wide">
                                                <p>訂單：不在訂單內</p>
                                                <p>檔案名稱：N/A</p>
                                                <p>備註：N/A</p>
                                            </td>
                                            <td class="four wide">
                                            </td>
                                            <td class="four wide">
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="ui basic black mini label" v-for="(core_waybill, index) in cws" style="margin:0;">
                                    {{ index+1 }}.{{ core_waybill.number }}@{{ latest_condition_time(core_waybill) }}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        show_contents: Boolean,
        core_waybills: Array,
        logo_url: String,
        title: String,
        sub_title: String,
        customer_service_hotline: String,
        blank_value_text: String,
    },
    data() {
        return {
            errors: [],
            senders: [],
            consignees: [],
        }
    },
    mounted() {
    },
    computed: {
        check_core_waybills() {
            var allowed_sender_names = _.map(_.filter(this.$parent.senders, (o) => {
                return o.is_selected
            }), 'sender_name')
            var allowed_consignee_names = _.map(_.filter(this.$parent.consignees, (o) => {
                return o.is_selected
            }), 'consignee_name')
            return _.filter(
                this.core_waybills, (o) => {
                    return allowed_sender_names.includes(o.sender_name) && allowed_consignee_names.includes(o.consignee_company_name)
                }
            );
        },
    },
    methods: {
        latest_condition_time(core_waybill) {
            try {
                return this.human_datetime(core_waybill.condition.updated_at, "MMDDHHmm")
            } catch (e) {
                return "-"
            }
        },
        latest_status_time(core_waybill) {
            try {
                return this.human_datetime(core_waybill.latest_status.created_at, "MMDDHHmm")
            } catch (e) {
                return "-"
            }
        },
    },
    components: {
    }
}
</script>

<style scoped>
table {
    border-color:  black !important;
}
table td, th{
    border-color:  black !important;
}
</style>
